<!-- 購入時の人数選択 ラジオボタンorセレクトボックス-->
<template>
  <div>
    <!-- gettable_countsの合計が0の場合 -->
    <div v-if="!isAvailablePurchase" class="unavailable-purchase-block">
      <p class="label">{{ $t("common.passengers") }}</p>
      <p class="error-message">上限枚数に達しています</p>
    </div>

    <!-- ラジオボタン式で、１枚のみ購入可能なチケット -->
    <TheMbDivisionCountRadio
      v-else-if="isRadio"
      :data-divisions="dataDivisions"
      :change-radio="changeRadio"
    />

    <!-- select式で、複数枚購入可能なチケット -->
    <TheMbDivisionCountSelect
      v-else-if="isSelectBox"
      :data-divisions="dataDivisions"
    />
  </div>
</template>

<script>
import { useStore } from "vuex";
import { onMounted, computed, watchEffect, ref } from "vue";

import divisionService from "@/services/bookBookingDivision";

export default {
  name: "TheMbDivisionCount",
  props: {
    dataDivisions: {
      type: Array,
      required: true,
    },
    changeRadio: {
      type: Function,
      required: true,
    },
    setStatusIsRadio: {
      type: Function,
      required: true,
    },
  },
  setup(props) {
    const store = useStore();

    const masterBook = computed(() => store.getters["ticketing/masterBook"]);
    const isRadio = computed(() =>
      divisionService.checkIsRadio(masterBook.value)
    );
    const isSelectBox = computed(() =>
      divisionService.checkIsSelectBox(masterBook.value)
    );
    const isAvailablePurchase = computed(() =>
      divisionService.checkIsAvailablePurchase(masterBook.value)
    );

    watchEffect(() => {
      if (isRadio.value) {
        props.setStatusIsRadio(isRadio.value);
      }
    });

    return {
      isRadio,
      isSelectBox,
      isAvailablePurchase,
    };
  },
};
</script>

<style lang="scss" scoped>
.unavailable-purchase-block {
  margin: 10px 0;

  p {
    display: inline-block;
  }
}

.label {
  margin-left: 16px !important;
  font-size: 13px !important;
  font-weight: normal;
  color: #888888;
}

.error-message {
  margin-left: 70px !important;
  font-size: 16px !important;
  font-weight: bold;
  color: #ff3333;
}
</style>
